import React, { useEffect, useState } from "react";
import CommonPaginationSection from "../../common/CommonPaginationSection";
import CustomerDetailActivityLog from "./CustomerDetailActivityLog";
import getUserActivityLogs from "../../../controllers/customer/getUserActivityLogs";
import { configurations } from "../../../configurations";

function CustomerDetailActivityLogsSection({ data }) {
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    total: 10,
  });
  const [items, setItems] = useState([]);

  const loadData = async () => {
    setLoading(true);
    const query = {
      limit: pagination?.perPage,
      offset: (pagination?.page - 1) * pagination?.perPage,
      filterBy: "account",
      filterValue: data?._id,
    };

    const res = await getUserActivityLogs(
      new URLSearchParams(query)?.toString()
    ).finally(() => setLoading(false));
    if (res?.return) {
      setItems(
        res?.data?.data?.map((item) => {
          let logType = "";
          const flightKeywords = ["flight"];
          const hotelKeywords = ["hotel", "accommodation", "stay"];
          const tourKeywords = ["tour", "package"];
          const insuranceKeywords = ["insurance", "policy", "protection"];
          const description = `${item?.action?.toLowerCase()} ${item?.details?.toLowerCase()}`;
          if (flightKeywords.some((keyword) => description.includes(keyword))) {
            logType = configurations.services.flight.code;
          } else if (
            hotelKeywords.some((keyword) => description.includes(keyword))
          ) {
            logType = configurations.services.stay.code;
          } else if (
            tourKeywords.some((keyword) => description.includes(keyword))
          ) {
            logType = configurations.services.tour.code;
          } else if (
            insuranceKeywords.some((keyword) => description.includes(keyword))
          ) {
            logType = configurations.services.insurance.code;
          }
          return { ...item, type: logType };
        })
      );
      setPagination({ ...pagination, total: res?.data?.meta?.total });
    }
  };

  useEffect(() => {
    loadData();
  }, [pagination.page, pagination.perPage]);

  return (
    <div className="w-full flex p-4 flex-col">
      <span className="font-bold mb-2">Recent activity</span>
      {loading ? (
        <div className="w-full flex items-center justify-center py-4">
          <div className="primaryLoader"></div>
        </div>
      ) : (
        <>
          <div className="w-full flex flex-col items-center gap-2">
            {items.map((item, itemIndex) => (
              <CustomerDetailActivityLog key={itemIndex} log={item} />
            ))}
          </div>
          <div className="w-full mt-2">
            <CommonPaginationSection
              perPage={pagination.perPage}
              total={pagination.total}
              page={pagination.page}
              callback={(pg, perPage) =>
                setPagination({ ...pagination, page: pg, perPage })
              }
            />
          </div>
        </>
      )}
    </div>
  );
}

export default CustomerDetailActivityLogsSection;
